import { useState, type FormEvent } from 'react'
import { guildApi } from '@/lib/guildApi'
import { describeError } from '@/lib/auth'
import { Modal } from '../settings/Modal'
import { Field } from '@/pages/AuthPage'
import auth from '@/pages/AuthPage.module.css'
import layer from '../settings/SettingsLayer.module.css'
import gs from './GuildSettingsLayer.module.css'
import styles from './ClaimModal.module.css'
import type { Role } from '@/types/api'

/** Код переноса из Discord: участник вводит свой код из таблицы владельца и получает роли и личные права. */
export function ClaimModal({ guildId, onClose }: { guildId: string; onClose: () => void }) {
  const [code, setCode] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [granted, setGranted] = useState<Role[] | null>(null)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    if (code.trim().length < 6) return
    setBusy(true)
    setError(null)
    try {
      const r = await guildApi.claimImport(guildId, code.trim())
      setGranted(r.roles)
    } catch (err) {
      const d = describeError(err)
      setError(d.fields.code ?? d.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <Modal title="Код переноса из Discord" onClose={onClose}>
      {granted ? (
        <>
          <p className={layer.text}>
            {granted.length ? `Готово: вы получили ${granted.map((r) => `«${r.name}»`).join(', ')}.` : 'Код принят, но ролей для вас в архиве не было — личные права, если они были, применены.'}
          </p>
          <div className={layer.buttonRow}>
            <button type="button" className={layer.button} onClick={onClose}>Закрыть</button>
          </div>
        </>
      ) : (
        <form className={styles.form} onSubmit={submit}>
          <p className={styles.text}>Владелец сервера раздал коды из таблицы, которую получил при переносе из Discord. Код возвращает роли и личные права, которые были у вас на том сервере. Код одноразовый.</p>
          <Field label="Код" htmlFor="claim-code" error={error ?? undefined}>
            <input id="claim-code" className={auth.input} value={code} autoFocus placeholder="XXXX-XXXX-XXXX" maxLength={64} onChange={(e) => setCode(e.target.value.toUpperCase())} />
          </Field>
          <div className={layer.buttonRow}>
            <button type="submit" className={layer.button} disabled={busy || code.trim().length < 6}>{busy ? 'Проверяем…' : 'Применить'}</button>
            <button type="button" className={gs.smallButton} onClick={onClose}>Отмена</button>
          </div>
        </form>
      )}
    </Modal>
  )
}
